import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index/home')
    },
    {
      path: '/web',
      name: 'Web',
      component: () => import('@/views/index/web')
    },
    {
      path: '/regist',
      name: 'Regist',
      component: () => import('@/views/regist/index')
    },
    {
      path: '/notice/list',
      name: 'NoticeList',
      component: () => import('@/views/notice/notice-list')
    },
    {
      path: '/notice/detail',
      name: 'NoticeDetail',
      component: () => import('@/views/notice/notice-detail')
    },
    {
      path: '/course/newest',
      name: 'CourseNewest',
      component: () => import('@/views/course/course-newest')
    },
    {
      path: '/charge/charge',
      name: 'Charge',
      component: () => import('@/views/charge/course-newest')
    },
    {
      path: '/course/list',
      name: 'CourseList',
      component: () => import('@/views/course/course-list')
    },
    {
      path: '/course/search',
      name: 'CourseSearch',
      component: () => import('@/views/course/course-search')
    },
    {
      path: '/course/detail',
      name: 'CourseDetail',
      component: () => import('@/views/course/course-detail')
    },
    {
      path: '/exam/survey',
      name: 'ExamSurvey',
      component: () => import('@/views/exam/exam-survey')
    },
    {
      path: '/exam/surveyResult',
      name: 'ExamSurveyResult',
      component: () => import('@/views/exam/exam-survey-result')
    },
    {
      path: '/exam/paper',
      name: 'ExamPaper',
      component: () => import('@/views/exam/exam-paper')
    },
    {
      path: '/exam/paperResult',
      name: 'ExamPaperResult',
      component: () => import('@/views/exam/exam-paper-result')
    },
    {
      path: '/live/list',
      name: 'LiveList',
      component: () => import('@/views/live/live-list')
    },
    {
      path: '/live/detail',
      name: 'LiveDetail',
      component: () => import('@/views/live/live-detail')
    },
    {
      path: '/expert/forum',
      name: 'ExpertForum',
      component: () => import('@/views/expert/forum')
    },
    {
      path: '/expert/list',
      name: 'ExpertList',
      component: () => import('@/views/expert/expert-list')
    },
    {
      path: '/expert/detail',
      name: 'ExpertDetail',
      component: () => import('@/views/expert/expert-detail')
    },
    {
      path: '/short-video/list',
      name: 'ShortVideoList',
      component: () => import('@/views/short-video/short-video-list')
    },
    {
      path: '/short-video/detail',
      name: 'ShortVideoDetail',
      component: () => import('@/views/short-video/short-video-detail')
    },
    {
      path: '/person-info',
      name: 'PersonInfo',
      component: () => import('@/views/user-center/person-info')
    },
    {
      path: '/score',
      name: 'Score',
      component: () => import('@/views/score/score')
    },
    {
      path: '/score-rule',
      name: 'ScoreRule',
      component: () => import('@/views/score/score-rule')
    },
    {
      path: '/exchange-record',
      name: 'ExchangeRecord',
      component: () => import('@/views/user-center/exchange-record')
    },
    {
      path: '/my-study',
      name: 'MyStudy',
      component: () => import('@/views/user-center/my-study')
    },
    {
      path: '/study-remind',
      name: 'StudyRemind',
      component: () => import('@/views/user-center/study-remind')
    },
    {
      path: '/data-center',
      name: 'DataCenter',
      component: () => import('@/views/user-center/data-center')
    },
    {
      path: '/data-detail',
      name: 'DataDetail',
      component: () => import('@/views/user-center/data-detail')
    },
    {
      path: '/my-meeting',
      name: 'MyMeeting',
      component: () => import('@/views/user-center/my-meeting')
    },
    {
      path: '/my-question',
      name: 'MyQuestion',
      component: () => import('@/views/user-center/my-question')
    },
    {
      path: '/my-message',
      name: 'MyMessage',
      component: () => import('@/views/user-center/my-message')
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: () => import('@/views/user-center/feedback')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js